import { render, staticRenderFns } from "./MenuSidebarItem.vue?vue&type=template&id=4d5ebffd"
import script from "./MenuSidebarItem.vue?vue&type=script&lang=js"
export * from "./MenuSidebarItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports